import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import { DEFAULT_PAGE_SIZE } from '../config/config';
import NewsletterService from '../services/NewsletterService';
import { PaginationParams } from '../types';
import { Material } from '../types/Material';
import { mapErrorMessage } from '../utils/mapErrorMensage';


class NewsletterStore {
    loading: boolean = false;
    newsletterList: any[] = [];
    newsletter: any | undefined;
    sort?: string = '';
    totalPages: number = 0;
    page: number = 0;
    totalElements: number = 0;
    size: number = DEFAULT_PAGE_SIZE;
    defaultparams = {
        size: DEFAULT_PAGE_SIZE,
        page: 0,
        sort: 'created,desc',
        search: '',
    }

    reset() {
        this.newsletter = undefined;
        this.newsletterList = [];
    }

    constructor() {
        makeAutoObservable(this);
    }

    async getList(params: PaginationParams) {
        this.loading = true;
        const response = await NewsletterService.getList(params);

        runInAction(() => {
            if (!response.error) {
                this.newsletterList = response.data.content;
                this.totalPages = response.data.totalPages;
                this.page = response.data.number;
                this.totalElements = response.data.totalElements;
                this.size = response.data.size;
                this.sort = params.sort;
            }
            this.loading = false;
        });
        return response;
    }

    async createNewsletter(newsletter: Material) {
        this.loading = true;
        const response = await NewsletterService.createNewsletter(newsletter);

        runInAction(() => {
            if (response.error) {
                message.error(mapErrorMessage(response?.details?.response?.data?.message));
                this.newsletter = newsletter;
            } else {
                message.success('Newsletter cadastrado com sucesso!');
            }
            this.loading = false;
        });

        return response;
    }

    async editNewsletter(newsletter: any, uuid: string | undefined) {
        this.loading = true;
        const response = await NewsletterService.editNewsletter(newsletter, uuid);

        runInAction(() => {
            if (response.error) {
                message.error(mapErrorMessage(response?.details?.response?.data?.message));
                this.newsletter = newsletter;
            } else {
                message.success('Newsletter editado com sucesso!');
            }
            this.loading = false;
        });

        return response;
    }

    async sendNewsletter(uuid: string | undefined) {
        this.loading = true;
        const response = await NewsletterService.sendNewsletter(uuid);

        runInAction(() => {
            if (response.error) {
                message.error(mapErrorMessage(response?.details?.response?.data?.message));
            } else {
                message.success('Newsletter enviada com sucesso!');
            }
            this.loading = false;
        });

        return response;
    }

    async getNewsletterByUuid(uuid: string) {
        this.loading = true;
        const response = await NewsletterService.getNewsletterByUuid(uuid);

        runInAction(() => {
            if (response.error) {
                message.error(`Erro ao buscar Newsletter`);
                return;
            }
            this.newsletter = response.data;
            this.loading = false;
        });

        return response;
    }

    async deleteNewsletters(uuid: string) {
        this.loading = true;
        const response = await NewsletterService.deleteNewsletter(uuid);

        runInAction(() => {
            if (response.error) {
                message.error('Erro ao deletar Newsletter');
            } else {
                message.success('Newsletter deletado com sucesso!');
                this.newsletter = undefined;
            }
            this.loading = false;
        });

        return response;
    }

    async deleteNewslettersAll(uuid: string) {
        this.loading = true;
        const response = await NewsletterService.deleteNewsletter(uuid);

        runInAction(() => {
            if (!response.error) {
                this.newsletter = undefined;
            }
            this.loading = false;
        });

        return response;
    }
}

const newsletterStore = new NewsletterStore();
export default newsletterStore;